import {
  queryOptions,
  type UseQueryOptions,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import { ItemTypeApi } from '@/common/api/itemType';
import type { ItemType } from '@/common/api/types/itemType';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { associateById } from '@/common/utils/associateById';

export const itemTypesQueryOptions = () => {
  return queryOptions<ItemType[]>({
    queryKey: commonQueryKeys.itemTypes.all,
    queryFn: () => ItemTypeApi.getItemTypes(),
  });
};

export const useItemTypesQuery = (options: Partial<UseQueryOptions<ItemType[]>> = {}) => {
  return useQuery({
    ...itemTypesQueryOptions(),
    ...options,
  });
};

export const useItemTypesByIdQuery = (options: Partial<UseQueryOptions<ItemType[]>> = {}) => {
  return useQuery({
    ...itemTypesQueryOptions(),
    ...options,
    select: associateById,
  });
};

export const useSuspenseItemTypesQuery = (
  options: Partial<Omit<UseQueryOptions<ItemType[]>, 'queryKey' | 'queryFn'>> = {},
) => {
  return useSuspenseQuery({ ...itemTypesQueryOptions(), ...options });
};
